var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseDialog',_vm._b({attrs:{"title":"提示","width":"576px"},on:{"close":function($event){return _vm.$emit('close')},"confirm":function($event){return _vm.$emit('confirm')}}},'BaseDialog',_vm.$attrs,false),[_c('div',{staticClass:"mb-[40px]"},[_c('p',[_vm._v(" 將變更所有舊會員的「權益政策同意狀態」，由「已同意」改為「未同意」。 此變更不可回復，是否確認變更？ ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }